(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('selectWarehouse', function (Warehouse) {
            return {
                require: '^ngModel',
                scope: {
                    type: "=",
                    modelValue: '=ngModel',
                    options: '=',
                    onSelect: '&'
                },
                templateUrl: 'app/entities/warehouse/select-warehouse.html',
                link: function (scope, $element, $attrs, ngModelCtrl) {

                    var defaultOptions = {
                        // activityFiltering: true
                    };

                    scope.requestOptions = angular.extend({}, defaultOptions, scope.options);
                    var queryPromise = Warehouse.autocomplete(scope.requestOptions).$promise;
                    queryPromise
                        .then(function (items) {
                            scope.items = items;
                        })
                        .catch(function (reason) {
                            scope.items = [];
                        });

                    scope.setValue = function (value) {
                        // if (typeof scope.onSelect === 'function') {
                        //     scope.onSelect(value);
                        // }
                        // console.log(c);
                        scope.onSelect({$id: value.id, $model: value});
                        ngModelCtrl.$setViewValue(value);
                    };

                }
            };
        });

})();
